<template>
  <div class="table-responsive" ref="table" style="min-height: 220px">
    <dynamic-table :columns="assignedReviewersColumns"
                   :data="assignedReviewers"
                   :loading="loading"
                   class="table-hover"
                   empty-message="No se han asignado revisores.">
      <template v-slot:researcher_status_key="slotProps">
          <span :class="showReviewerStatus(slotProps.row.researcher_status_key).class"
                class="badge">{{ showReviewerStatus(slotProps.row.researcher_status_key).title }}</span>
      </template>
      
      <template v-slot:dictum_type_title="slotProps">
        <span v-if="getDictum(slotProps.row) === 'Aprobado'"
            class="badge badge-success">{{ getDictum(slotProps.row) }}</span>
        <span
            v-else-if="getDictum(slotProps.row) === 'No aprobado' || getDictum(slotProps.row) === 'Rechazado'"
            class="badge badge-subtle badge-danger">{{ getDictum(slotProps.row) }}</span>
        <span v-else
            class="badge badge-subtle badge-dark">{{ getDictum(slotProps.row) }}</span>
      </template>
      
      <template v-slot:dictum_created_at="slotProps">
        <template v-if="getDateDictum(slotProps.row) !== 'Sin fecha'">
          {{ getDateDictum(slotProps.row) }}
        </template>
        <span v-else
            class="badge badge-subtle badge-dark">{{ getDateDictum(slotProps.row) }}</span>
      </template>
      
      <template v-slot:protocol_review_created_at="slotProps">
        {{ getAssignmentDate(slotProps.row) }}
      </template>

      <template v-slot:num_revision="slotProps">
        {{ getNumRevision(slotProps.row) }}
      </template>
      
      <template v-slot:actions="slotProps">
        <div class="list-group-item-figure align-items-start justify-content-center">
          <div class="dropdown">
            <button aria-expanded="false" class="btn btn-sm btn-icon btn-light"
                    data-toggle="dropdown">
              <i class="fa fa-fw fa-ellipsis-v"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right" style="">
              <div class="dropdown-arrow mr-n1"></div>
              <button class="dropdown-item"
                      type="button"
                      @click="openCommentsModal(getDictumComments(slotProps.row))"
                      :disabled="!hasComments(slotProps.row)">
                Ver comentarios del revisor
              </button>
              <button class="dropdown-item" type="button"
                      @click="resendInvitation(slotProps.row.user_id)">
                Enviar recordatorio al revisor
              </button>
              <button class="dropdown-item" type="button"
                      :disabled="slotProps.row.researcher_status_key !== 'aceptado'"
                      @click="createDictumTask(slotProps.row)">
                Crear tarea a revisor para un nuevo dictamen
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" type="button"
                      data-toggle="modal"
                      data-target="cancel-protocol"
                      :disabled="slotProps.row.researcher_status_key !== 'enviado'"
                      @click="$emit('cancel-reviewer', slotProps.row.user_id)">
                Cancelar revisor
              </button>
            </div>
          </div>
        </div>
      </template>
    </dynamic-table>
    <portal to="task-modals">
      <ok-cancel-dialog title="Crear tarea a revisor"
                        id="create-task-modal"
                        ref="create-task-modal"
                        content="<p>¿Esta seguro de crear tarea al revisor?</p>"
                        ok-button-text="Confirmar"
                        :ok-callback="createTask"></ok-cancel-dialog>
    </portal>
  </div>
</template>

<script>
  import DynamicTable from '../../ui/DynamicTable'
  import OkCancelDialog from '../../ui/OkCancelDialog'
  import { mapActions, mapGetters } from 'vuex'
  import { AlertManager } from '../../utils/AlertManager'
  
  export default {
    name: 'AssignedReviewers',
    components: {
      DynamicTable,
      OkCancelDialog,
    },
    props: {
      protocol: Object,
      committee: Object,
    },
    data () {
      return {
        loading: true,
        assignedReviewersColumns: [
          {
            field: 'full_name',
            title: 'Nombre',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'researcher_status_key',
            title: 'Respuesta',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'protocol_review_created_at',
            title: 'Fecha de asignación',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'dictum_type_title',
            title: 'Dictamen',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'dictum_created_at',
            title: 'Fecha dictamen',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'num_revision',
            title: 'Revisión',
            tdClass: 'align-middle text-center',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'actions',
            title: 'Acciones',
            tdClass: 'align-middle text-center',
            tdStyle: {},
            thClass: 'align-middle text-center',
            thStyle: {},
          },
        ],
        selectedReviewer: null,
      }
    },
    methods: {
      ...mapActions({
        getAssignedReviewers: 'committees/getAssignedReviewers',
        resendInvitationToUser: 'committees/resendInvitationReviewer',
        createReviewerDictumTask: 'committees/createReviewerDictumTask',
      }),
      async load () {
        this.loading = true
        
        const {
                committee,
                protocol,
              } = this
        
        await this.getAssignedReviewers({
          protocol,
          committee,
        })
        
        this.loading = false
      },
      openCommentsModal (comments) {
        this.$emit('show-comments', comments)
      },
      showReviewerStatus (key) {
        const titleStatuses = {
          enviado: {
            title: 'Pendiente por investigador',
            class: 'badge-primary',
          },
          aceptado: {
            title: 'Investigador aceptó invitación',
            class: 'badge-success',
          },
          rechazado: {
            title: 'Investigador rechazó invitación',
            class: 'badge-warning',
          },
          cancelado: {
            title: 'El comité canceló la invitación',
            class: 'badge-subtle badge-danger',
          },
          ignorado: {
            title: 'Petición ignorada por el coinvestigador.',
            class: 'badge-subtle badge-dark',
          },
          default: {
            title: 'El comité canceló la invitación',
            class: 'badge-subtle badge-dark',
          },
        }
        
        if (key in titleStatuses) {
          return titleStatuses[key]
        }
        
        return titleStatuses.default
      },
      async resendInvitation (user) {
        const {
                committee,
                protocol,
              } = this
        
        const response = await this.resendInvitationToUser({
          user,
          committee,
          protocol,
        })
        
        const {
                status,
                error,
                message,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return
        }
        
        AlertManager.success(message)
      },
      createDictumTask (assignedReviewer) {
        
        const totalDictumsTypes = {
          'etica': 'total_dictums_ethics',
          'investigacion': 'total_dictums_research',
          'bioseguridad': 'total_dictums_biosecurity',
        }
        
        const totalPendingTasksTypes = {
          'etica': 'total_pending_tasks_ethics',
          'investigacion': 'total_pending_tasks_research',
          'bioseguridad': 'total_pending_tasks_biosecurity',
        }

        const totalPendingReviewerTasksTypes = {
          'etica': 'total_pending_reviewer_tasks_ethics',
          'investigacion': 'total_pending_reviewer_tasks_research',
          'bioseguridad': 'total_pending_reviewer_tasks_biosecurity',
        }
        
        const dictumsKey = totalDictumsTypes[this.committee.key]
        const pendingTasksKey = totalPendingTasksTypes[this.committee.key]
        const pendingReviewerTasksKey = totalPendingReviewerTasksTypes[this.committee.key]
        
        if (assignedReviewer.researcher_status_key === 'aceptado' &&
          assignedReviewer[dictumsKey] > 0 &&
          assignedReviewer[pendingTasksKey] === 0
        ) {
          this.selectedReviewer = assignedReviewer
          $('#create-task-modal').modal('show')
        }
        else {
          
          let message = ''
          
          if (assignedReviewer.researcher_status_key === 'rechazado') {
            message = 'No se puede crear la tarea al revisor porque ha rechazado la invitación'
          }
          else if (assignedReviewer[pendingReviewerTasksKey] > 0) {
            message = 'El revisor ya cuenta con una tarea registrada'
          }
          else {
            message = 'No se puede crear la tarea al revisor porque aún no ha dictaminado.'
  
            this.selectedReviewer = assignedReviewer
            $('#create-task-modal').modal('show')
            
            return
          }
          
          AlertManager.error(message)
        }
      },
      async createTask () {
        const {
                committee,
                protocol,
                selectedReviewer,
              } = this
        
        const response = await this.createReviewerDictumTask({
          user: selectedReviewer.user_id,
          committee: committee.id,
          protocol: protocol.id,
        })
        
        const {
                status,
                error,
                message,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return
        }
        
        await this.getAssignedReviewers({
          protocol,
          committee,
        })
        
        AlertManager.success(message)
      },
      
      getDictum (data) {
        const taskStatuses = {
          etica: data.ethics_reviewer_task_status_key,
          bioseguridad: data.biosecurity_reviewer_task_status_key,
          investigacion: data.research_reviewer_task_status_key,
        }

        if (taskStatuses[this.committee.key] && taskStatuses[this.committee.key] === 'registrada') {
          return 'Sin dictamen'
        }

        const dictums = {
          etica: data.ethics_dictum_type_title,
          bioseguridad: data.biosecurity_dictum_type_title,
          investigacion: data.research_dictum_type_title,
        }
        
        return dictums[this.committee.key] ? dictums[this.committee.key] : 'Sin dictamen'
      },
      
      getDateDictum (data) {
        const taskStatuses = {
          etica: data.ethics_reviewer_task_status_key,
          bioseguridad: data.biosecurity_reviewer_task_status_key,
          investigacion: data.research_reviewer_task_status_key,
        }

        if (taskStatuses[this.committee.key] && taskStatuses[this.committee.key] === 'registrada') {
          return 'Sin fecha'
        }

        if (this.committee.key === 'etica' && data.ethics_dictum_type_title) {
          return data.ethics_reviewer_dictum_created_at
        }
        else if (this.committee.key === 'bioseguridad' && data.biosecurity_dictum_type_title) {
          return data.biosecurity_reviewer_dictum_created_at
        }
        else if (data.research_dictum_type_title) {
          return data.research_reviewer_dictum_created_at
        } else {
          return 'Sin fecha'
        }
      },

      getAssignmentDate (data) {
        const dates = {
          etica: data.ethics_reviewer_task_created_at,
          bioseguridad: data.biosecurity_reviewer_task_created_at,
          investigacion: data.research_reviewer_task_created_at,
        }

        return dates[this.committee.key]
      },
      
      hasComments (data) {
        const taskStatuses = {
          etica: data.ethics_reviewer_task_status_key,
          bioseguridad: data.biosecurity_reviewer_task_status_key,
          investigacion: data.research_reviewer_task_status_key,
        }

        if (taskStatuses[this.committee.key] && taskStatuses[this.committee.key] === 'registrada') {
          return false
        }

        if (this.committee.key === 'etica' && data.ethics_dictum_type_title) {
          return true
        }
        else if (this.committee.key === 'bioseguridad' && data.biosecurity_dictum_type_title) {
          return true
        }
        else if (data.research_dictum_type_title) {
          return true
        } else if (data.protocol_review_justification) {
          return true
        }
        
        return false
      },
      
      getDictumComments (data) {
        const comments = {
          etica: data.ethics_reviewer_dictum_comments,
          bioseguridad: data.biosecurity_reviewer_dictum_comments,
          investigacion: data.research_reviewer_dictum_comments,
        }
        
        if (comments[this.committee.key]) {
          return comments[this.committee.key]
        } else if (data.protocol_review_justification) {
          return data.protocol_review_justification
        }

        return ''
      },
  
      getNumRevision (data) {
        const revisions = {
          etica: data.revisions_ethics,
          bioseguridad: data.revisions_biosecurity,
          investigacion: data.revisions_research,
        }
    
        const revision = revisions[this.committee.key]
        
        return parseInt(revision) + 1
      },
    },
    computed: {
      ...mapGetters({
        assignedReviewers: 'committees/assignedReviewers',
      }),
    },
    async mounted () {
      await this.load()
    },
  }
</script>
